import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as bookablePackageRateAction from '../../../../actions/bookablePackageRateAction';
import BookablePackageRate from './BookablePackageRate';
import * as hotelActions from './../../../../actions/hotelAction';

const mapStateToProps = state => {
    return {
        bookablePackageRateState: state.bookablePackageRateReducer,
        hotelState: state.hotelReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListBookablePackageRates: (hotelId, filters) => {
            dispatch(bookablePackageRateAction.getListBookablePackageRates(hotelId, filters))
        },
        sortBookablePackageRates: (data, hotelId) => dispatch(bookablePackageRateAction.sortBookablePackageRate(data, hotelId)),
        updateBookablePackageRate: (data, id, callbacks) => dispatch(bookablePackageRateAction.updateBookablePackageRate(data, id, callbacks)),
        syncAllBookablePackageRates: (hotelId, isRefresh) => dispatch(bookablePackageRateAction.syncBookablePackageRates(hotelId, isRefresh)),
        syncOneBookablePackageRate: (id) => dispatch(bookablePackageRateAction.syncBookablePackageRate(id)),
        getHotelDetail: (id) => dispatch(hotelActions.getHotelDetail(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(BookablePackageRate));
